module.exports = __webpack_public_path__ + "static/media/9DESA13.980c4b16.jpg";